// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__22y71","info":"UpdateTermsInfo_info__3CWMM"};